import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "codes-list" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "codes-title iodine-padding-top-md iodine-padding-bottom-sm" }, " Codes ", -1)
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }

import {ref, Ref} from 'vue';
    import {CodesItemDataModel} from 'components/resources/CodesItemData.model';
    import CodesItem from 'components/resources/CodesItem.vue';

    export interface Props {
        codesList: CodesItemDataModel[] | null,
        expanded?: boolean
    }

    
export default /*#__PURE__*/_defineComponent({
  __name: 'CodesList',
  props: {
    codesList: { default: null },
    expanded: { type: Boolean, default: false }
  },
  setup(__props: any) {

    const props = __props;

    const expanded: Ref<boolean> = ref(props.expanded)


return (_ctx: any,_cache: any) => {
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_list = _resolveComponent("q-list")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_q_list, { dense: "" }, {
      default: _withCtx(() => [
        (props.codesList && (expanded.value || props.codesList.length <= 5))
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.codesList, (item) => {
                return (_openBlock(), _createBlock(_component_q_item, {
                  dense: "",
                  class: "codes-item",
                  key: item.value
                }, {
                  default: _withCtx(() => [
                    _createVNode(CodesItem, { "codes-item-data-model": item }, null, 8, ["codes-item-data-model"])
                  ]),
                  _: 2
                }, 1024))
              }), 128)),
              _withDirectives(_createElementVNode("div", null, [
                _createElementVNode("a", {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (expanded.value = false))
                }, [
                  _createTextVNode(" Show only 5 matching codes   "),
                  _createVNode(_component_q_icon, {
                    name: "fa-solid fa-angle-up",
                    class: "iodine-small-icon"
                  })
                ])
              ], 512), [
                [_vShow, props.codesList.length > 5]
              ])
            ]))
          : (props.codesList)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (index) => {
                  return _createVNode(_component_q_item, {
                    dense: "",
                    class: "codes-item",
                    key: index
                  }, {
                    default: _withCtx(() => [
                      _createVNode(CodesItem, {
                        "codes-item-data-model": props.codesList[index]
                      }, null, 8, ["codes-item-data-model"])
                    ]),
                    _: 2
                  }, 1024)
                }), 64)),
                _createElementVNode("div", null, [
                  _createElementVNode("a", {
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (expanded.value = true))
                  }, [
                    _createTextVNode(" Show all " + _toDisplayString(props.codesList?.length) + " matching codes   ", 1),
                    _createVNode(_component_q_icon, {
                      name: "fa-solid fa-angle-down",
                      class: "iodine-small-icon"
                    })
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})